import {StyleSheet} from 'react-native';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// (tagContainer) are preserved — the factory returns them closed over the
// theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      borderRadius: 16,
      borderColor: colors.borderMuted,
      borderWidth: 1,
      alignSelf: 'flex-end',
    },
    searchContainer: {
      paddingHorizontal: 16,
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
    },
    searchInput: {
      fontFamily: FONTS.regularFont,
      color: colors.textPrimary,
      fontSize: 16,
      flex: 1,
      paddingVertical: 16,
    },
    closeButtonContainer: {
      paddingVertical: 16,
      paddingLeft: 16,
    },
    filterButtonContainer: {
      paddingVertical: 16,
      paddingHorizontal: 18,
      borderLeftColor: colors.borderMuted,
      borderLeftWidth: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    marginTop16: {
      marginTop: 16,
    },
    marginLeft16: {
      marginLeft: 16,
    },
    tagContainer: index => ({
      padding: 8,
      borderRadius: 8,
      backgroundColor: colors.surface,
      marginLeft: index == 0 ? 0 : 16,
      flexDirection: 'row',
      alignItems: 'center',
    }),
  });

export default makeStyles;
